















import { defineComponent } from '@vue/composition-api';
import BasePage from '../../components/base/BasePage.vue';
import { HeroBanner } from '../../components/base';
import { HostingPageInformation } from '../../components/utils/useCustomerPageInformation.hooks';
import HostingSearch from '../../components/hosting/HostingSearch.vue';

export default defineComponent({
  name: 'HostingLanding',
  components: { HeroBanner, BasePage, HostingSearch },
  setup() {
    const { t, isReady, load } = HostingPageInformation;
    load();

    return { t, isReady };
  }
});
